export default __webpack_public_path__ + "static/media/blue-train-track-small.e8ab101f.svg";